import { Component, ElementRef, EventEmitter, HostListener, Inject, Injector, Input, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import { Message, TypeMessage, UserLandingsV2ModuleModel, UserLandingV2Item } from './user-landings-v2-models';
import { LandingModel } from 'projects/common/model/landingModel';
import { isPlatformBrowser } from '@angular/common';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { HttpClient } from '@angular/common/http';
import { ModalData, ModalService } from '@shopping-angular-components/modal';
import { TranslateService } from '@ngx-translate/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ConfirmButtonsComponent } from '../confirm-buttons/confirm-buttons.component';
import { UserLandingsContentModalComponent } from './user-landings-content-modal/user-landings-content-modal.component';
import { Device } from 'projects/common/model/Device';
import { UserLandingsService } from './user-landings.service';
import { UtilsService } from 'projects/common/services/utils.service';

declare var window: any;

@Component({
  selector: 'user-landings-v2',
  template: `
  <div #plannersContainer>
    <div class="trip-header">
      <h2 class="trip-wrapper-title eva-3-{{this.isDesktop ? 'h2' : 'h4'}}">{{'userLandings.title' | translate}}</h2>

      <eva-button *ngIf="isLogged" class="new-trip-button"
      [options]="{type: 'none', link_text: ('userLandings.btn.create' | translate), ghost_button: true, size: this.isDesktop ? '-md' : '-sm'}"
      [moduleId]="getModuleId()"
      [upaData]="{label: 'CREATE_TRIPPLANNER_BTN', data: this.module.data}"
      (clickEvent)="goToNewUserLanding()"></eva-button>
    </div>
        <ng-container *ngIf="hasItems() && isLogged; else emptyState" >
            <div class="user-landing-card-container">
              <ng-container *ngFor="let trip of module.data.trips; let i = index">
                <user-landings-card-v2 @fade [data]="trip" [upaData]="upaData"
                [moduleIndex]="moduleIndex" [moduleId]="moduleId" [uniqueId]="uniqueId" [device]="device" class="user-landing-card" (deleteEvent)="showDeleteConfirmationModal(trip)" (updateEvent)="showUpdateModal(trip)" [typeView]="this.device.type === 'MOBILE' ? 'horizontal' : 'vertical'"></user-landings-card-v2>
              </ng-container>
            </div>
        </ng-container>

        <ng-template #emptyState>
          <div class="empty-state -eva-3-mt-xsm" [ngClass]="{'eva-3-card': isDesktop }">
            <span [ngClass]="this.isLogged ? 'trip-guide-illustration' : 'login-heart-illustration' "></span>
            <h4 class="eva-3-{{this.isDesktop ? 'h3' : 'h4'}} -eva-3-mb-{{this.isDesktop ? 'sm' : 'xsm'}} -eva-3-mt-xsm">{{isLogged ? ('userLandings.emptyState.title' | translate ) : ('userLandings.emptyState.login.title' | translate)}}</h4>
            <p class="empty-state-text eva-3-{{this.isDesktop ? 'body-1' : 'body-2'}}">{{isLogged ? ('userLandings.emptyState.text' | translate) : ('userLandings.emptyState.login.text' | translate)}}</p>
            <eva-button class="-eva-3-mt-{{this.isDesktop ? 'lg' : 'md'}}"
              [options]="{type: '-primary', size: this.isDesktop ? '-lg' : '-md' ,link: isLogged ? ('userLandings.emptyState.CTALink' | translate) : ('userLandings.emptyState.login.CTALink' | translate), link_text: isLogged ? ('userLandings.emptyState.CTA' | translate) : ('userLandings.emptyState.login.CTA' | translate)}"
              [moduleId]="getModuleId()"
              [upaData]="{label: isLogged ? 'EMPTY_TRIPPLANNER_BTN_PRODUCTS' : 'EMPTY_TRIPPLANNER_BTN_LOGIN'}">
            </eva-button>
          </div>
        </ng-template>
    </div>

    <eva-message @fade *ngIf="message.show && message.type"
      [data]="{message_type: message.type, icon: message.icon, title: message.title, title_params: message.params, showCloseIcon: message.showEditButton ? false : true, showEditButton: message.showEditButton }"
      (close)="closeMessage()"
      ></eva-message>
  `,
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 }))
      ])
    ]),
  ],
  styleUrls: ['./user-landings-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserLandingsV2Component extends AbstractComponent implements OnInit {

  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() device: Device;
  @Input() override module: UserLandingsV2ModuleModel;

  @ViewChild('plannersContainer') plannersContainer: ElementRef<HTMLInputElement>;
  isDesktop: boolean = false;
  landingModel: LandingModel;
  fixedOnBottom = false;
  upaData: any;
  titleChanged: string = '';
  isLogged: boolean = false;
  sizeModal: string = '-sm'

  message: Message = {
    show: false,
    type: 'success',
    icon: '',
    title: '',
    params: {
      name: ''
    }
  };

  toastMessages = {
    success: {
      icon: 'checkmark-circle-filled',
      title: 'userLandings.toast.success',
      typeMessage: '-success'
    },
    update: {
      icon: 'checkmark-circle-filled',
      title: 'userLandings.toast.update',
      typeMessage: '-success'
    },
    delete: {
      icon: 'info-circle-filled',
      title: 'userLandings.toast.delete',
      typeMessage: '-info'
    },
    error: {
      icon: 'error-circle',
      title: 'userLandings.toast.error',
      typeMessage: '-error'
    },
  };

  constructor(
    injector: Injector,
    private modalService: ModalService,
    private translateService: TranslateService,
    private userLandingsService: UserLandingsService,
    private utilsService: UtilsService,
    @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
  }

  @HostListener('window:scroll') onScrollEvent() {
    this.fixedOnBottom = (this.plannersContainer.nativeElement.getBoundingClientRect().bottom + 64) > window.innerHeight;
  }

  ngOnInit(): void {
    this.isDesktop = this.device.type === "DESKTOP";
    // Valido que no este logeado || que no tenga forceSocial por header reconocido por despe
    this.isLogged = this.utilsService.isLogged() || (window.upaData.loggedLevel !== 'level0' && window.upaData.despegarid !== '');
    this.sizeModal = globalThis.innerWidth <= 1023 ? this.sizeModal : '';

    if (!this.isLogged && this.isDesktop) {
      window.location.href = this.translateService.instant('userLandings.emptyState.login.CTALink')
    }

    this.landingModel = this.landingModelService.getLandingModel();
    if (isPlatformBrowser(this.platformId)) {
      this.upaData = {
        uniqueId: this.uniqueId,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        target: UpaTarget.TRIP_PLANNER
      };
    }
  }

  redirectToLogin() {
    return '/login?ref=nymeria&redirect_to=/informacion/board-guiasdeviaje'
  }

  hasItems(): boolean {
    return this.module.data.trips.length > 0;
  }

  goToNewUserLanding() {
    window.location.href = this.translateService.instant('userLandings.formUrl');
  }

  showUpdateModal(item: UserLandingV2Item) {
    const newTitleEmitter = new EventEmitter<string>();
    newTitleEmitter.subscribe((newTitle: string) => this.handleTitleChange(newTitle));

    const modalData: ModalData = {
      id: 'user-landing-modal',
      title: this.translateService.instant('userLandings.modal.update.title'),
      size: this.sizeModal,
      contentComponent: UserLandingsContentModalComponent,
      contentModel: {
        title: item.title,
        titleChange: newTitleEmitter
      },
      footerComponent: ConfirmButtonsComponent,
      footerModel: {
        acceptCallback: () => {
          this.updateUserLanding(item);
        },
        acceptLabel: this.translateService.instant('userLandings.modal.update.button'),
        loaderLabel: this.translateService.instant('userLandings.buttonUpdateLoader'),
        isCancelable: false,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        uniqueId: this.uniqueId,
        size: globalThis.innerWidth <= 340 ? '-md' : '-lg',
        upaData: { ...this.upaData, data: item }
      },
      isWebview: this.landingModel.webview,
      product: 'nymeria-gui',
      flow: 'landing',
      forceHeader: true
    };

    this.modalService.showModal(modalData);
  }

  showDeleteConfirmationModal(item: UserLandingV2Item) {
    const modalData: ModalData = {
      id: 'user-landing-modal',
      title: this.translateService.instant('userLandings.modal.delete.title'),
      content: this.translateService.instant('userLandings.modal.delete.text'),
      size: this.sizeModal,
      footerComponent: ConfirmButtonsComponent,
      footerModel: {
        acceptCallback: () => {
          this.deleteUserLanding(item);
        },
        acceptLabel: this.translateService.instant('userLandings.modal.delete.button'),
        loaderLabel: this.translateService.instant('userLandings.buttonLoader'),
        isCancelable: false,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        uniqueId: this.uniqueId,
        size: globalThis.innerWidth <= 340 ? '-md' : '-lg',
        upaData: { ...this.upaData, data: item }
      },
      isWebview: this.landingModel.webview,
      product: 'nymeria-gui',
      flow: 'landing',
      forceHeader: true
    };

    this.modalService.showModal(modalData);
  }

  showMessage(messageType: TypeMessage, name?: string, showEditButton?: boolean) {
    const toastMessage = this.toastMessages[messageType];

    this.message = {
      ...this.message,
      type: toastMessage.typeMessage,
      icon: toastMessage.icon,
      title: toastMessage.title,
      showEditButton: showEditButton ?? false,
      show: true,
      params: {
        ...this.message?.params,
        name: name ?? ''
      }
    };

    setTimeout(() => {
      if (this.message) {
        this.message = { ...this.message, show: false };
      }

    }, 5000);
  }

  closeMessage() {
    if (this.message) {
      this.message = { ...this.message, show: false };
    }
  }

  handleTitleChange(newTitle: string): void {
    this.titleChanged = newTitle;
  }

  updateUserLanding(item: UserLandingV2Item) {
    if (item.title !== this.titleChanged && this.titleChanged !== '') {
      item.title = this.titleChanged;
      this.userLandingsService.updateUserLanding(item.id, { title: this.titleChanged }).subscribe({
        next: (response: any) => {
          this.showMessage('update');
          this.trackUpa('UPDATE_NAME_SUCCESS', item);
        },
        error: (err: any) => {
          this.showMessage('error');
          this.trackUpa('UPDATE_NAME_ERROR', item);
          this.modalService.closeModal();
        },
        complete: () => {
          this.modalService.closeModal();
        }
      });

      this.titleChanged = '';
    }
  }

  trackUpa(label: string, item: UserLandingV2Item) {
    let dataToTrack = { ...this.upaData, label: label };
    dataToTrack.data = item;

    this.upaService.trackClickTopic(dataToTrack);
  }

  getModuleId(): string {
    return this.moduleId
  }

  deleteUserLanding(item: UserLandingV2Item) {
    this.userLandingsService.deleteUserLanding(item.id, item.old_user_landing).subscribe({
      next: (response: any) => {
        const index = this.module.data.trips.indexOf(item);
        if (index > -1) {
          this.module.data.trips.splice(index, 1);
        }
        this.showMessage('delete');
        this.trackUpa('DELETE_TRIPPLANNER_SUCCESS', item);
      },
      error: (err: any) => {
        this.showMessage('error');
        this.trackUpa('DELETE_TRIPPLANNER_ERROR', item);
        this.modalService.closeModal();
      },
      complete: () => {
        this.modalService.closeModal();
      }
    });

  }
}
